import * as fb from "../../firebase";
// import router from "../../router";

import { BasicResponse, DataResponse } from "functions/src/responseTypes";
import {
  ADD_NODES_TO_USER,
  CHANGE_ROOT_USERNAME,
  doGetUserTree,
  doGetUserTreeBatch,
  GetUserTreeRequest,
  GetUserTreeBatchRequest,
  INIT,
  UserNetworkState,
  MARK_NODES_PENDING_UPDATE,
} from "./UserNetworkInterfaces";
import { ActionContext } from "vuex";
import {
  BinaryTreeNodeUser,
  SearchUserResponse,
} from "functions/src/Users/UsersInterfaces";

const initialState: UserNetworkState = {
  rootNodeUsername: "",
  binaryTreeNodes: new Array<BinaryTreeNodeUser>(),
  binaryTreeMap: new Map<string, BinaryTreeNodeUser>(),
  pendingUpdateNodes: new Set<string>(),
};

const state: UserNetworkState = { ...initialState };
const mutations = {
  INIT(state: UserNetworkState, currentUser: string) {
    state.rootNodeUsername = currentUser;
    state.binaryTreeNodes = new Array<BinaryTreeNodeUser>();
    state.binaryTreeMap = new Map<string, BinaryTreeNodeUser>();
    state.pendingUpdateNodes = new Set<string>();
  },
  ADD_NODES_TO_USER(state: UserNetworkState, tree: BinaryTreeNodeUser[]) {
    if (state.binaryTreeNodes.length == 0 || state.binaryTreeMap.size == 0) {
      //Assign tree and Create tree Map
      state.binaryTreeNodes = tree;
      tree.forEach((n) => {
        state.binaryTreeMap.set(n.username, n);
      });
    } else {
      //Find user to update
      // assign left and right children
      tree.forEach((n) => {
        const mapNode = state.binaryTreeMap.get(n.username);
        if (mapNode) {
          //If there is a node, update
          mapNode.loadedLevels = n.loadedLevels;
          mapNode.childLeft = n.childLeft;
          mapNode.childRight = n.childRight;
        } else {
          state.binaryTreeNodes.push(n);
          state.binaryTreeMap.set(n.username, n);
        }
      });
    }
  },
  CHANGE_ROOT_USERNAME(state: UserNetworkState, newUsername: string) {
    state.rootNodeUsername = newUsername;
  },
  MARK_NODES_PENDING_UPDATE(state: UserNetworkState, usernames: string[]) {
    usernames.forEach((username) => {
      state.pendingUpdateNodes.add(username);
    });
  },
  CLEAR_PENDING_FLAG(state: UserNetworkState, username: string) {
    state.pendingUpdateNodes.delete(username);
  },
  /**
   * Recibe `state` A PROPÓSITO: escrito sin parámetro usaba el objeto crudo del
   * módulo en lugar del Proxy reactivo de Vuex, y entonces el borrado no
   * invalidaba los getters. `getRootUserNode` seguía devolviendo, ya en la
   * sesión siguiente, el nodo raíz del usuario anterior, así que la vista daba
   * el árbol por cargado y no lo reconstruía. Mismo defecto que había en
   * `UnilevelStore`, explicado con detalle allí.
   */
  CLEAR_STATE(state: UserNetworkState) {
    Object.assign(state, {
      rootNodeUsername: "",
      binaryTreeNodes: new Array<BinaryTreeNodeUser>(),
      binaryTreeMap: new Map<string, BinaryTreeNodeUser>(),
      pendingUpdateNodes: new Set<string>(),
    });
  },
};

const actions = {
  async initializeTree(context: ActionContext<UserNetworkState, any>) {
    const loggedUsername = context.rootState.auth.userProfileData._usernamePK;
    const tree = context.getters.getTreeForUser(
      loggedUsername
    ) as BinaryTreeNodeUser;
    if (tree.username == undefined || tree.username == "") {
      context.commit(INIT, loggedUsername);
      await context.dispatch(doGetUserTree, {
        username: loggedUsername,
        levels: 4,
      });
    }
  },
  async doGetUserTree(
    context: ActionContext<UserNetworkState, any>,
    request: GetUserTreeRequest
  ) {
    const getBinaryTree = fb.func.httpsCallable("Users-getBinaryTree");
    const r = await getBinaryTree(request);
    const response: DataResponse<BinaryTreeNodeUser[]> | BasicResponse = r.data;
    if (response.OPCODE == "SUCCESS") {
      const tree: BinaryTreeNodeUser[] = (
        response as DataResponse<BinaryTreeNodeUser[]>
      ).data;
      context.commit(ADD_NODES_TO_USER, tree);
      // context.commit(CHANGE_ROOT_USERNAME, newUsername);
    } else if (response.OPCODE == "ERROR") {
      throw response.error;
    }
  },
  async doGetUserTreeBatch(
    context: ActionContext<UserNetworkState, any>,
    request: GetUserTreeBatchRequest
  ) {
    const getBinaryTreeBatch = fb.func.httpsCallable(
      "Users-getBinaryTreeBatch"
    );
    const r = await getBinaryTreeBatch(request);
    const response: DataResponse<BinaryTreeNodeUser[]> | BasicResponse = r.data;
    if (response.OPCODE == "SUCCESS" || response.OPCODE == "HAS-ERRORS") {
      const tree: BinaryTreeNodeUser[] = (
        response as DataResponse<BinaryTreeNodeUser[]>
      ).data;
      context.commit(ADD_NODES_TO_USER, tree);
    } else if (response.OPCODE == "ERROR") {
      throw response.error;
    }
  },
  async setRootUsername(
    context: ActionContext<UserNetworkState, any>,
    newUsername: string
  ) {
    const loggedUsername = context.rootState.auth.userProfileData._usernamePK;
    newUsername =
      newUsername == "" || newUsername == undefined
        ? loggedUsername
        : newUsername.toLowerCase();
    const tree = context.getters.getTreeForUser(
      newUsername
    ) as BinaryTreeNodeUser;
    if (
      tree.username == undefined ||
      tree.username == "" ||
      tree.loadedLevels < 4
    ) {
      // context.commit(INIT, newUsername);
      await context.dispatch(doGetUserTree, {
        username: newUsername,
        levels: 4,
      });
    }
    context.commit(CHANGE_ROOT_USERNAME, newUsername);
  },
  async searchUser(
    context: ActionContext<UserNetworkState, any>,
    username: string
  ) {
    username = username.trim().toLowerCase();
    if (username.includes("@")) {
      const searchUser = fb.func.httpsCallable("Users-searchUser");
      const r = await searchUser({ username: username });
      const response: DataResponse<SearchUserResponse> | BasicResponse = r.data;
      if (response.OPCODE == "SUCCESS") {
        username = (response as DataResponse<SearchUserResponse>).data
          .usernamePK;
      } else if (response.OPCODE == "ERROR") {
        throw response.error;
      }
    }
    const tree = context.getters.getTreeForUser(username) as BinaryTreeNodeUser;
    if (
      tree.username == undefined ||
      tree.username == "" ||
      tree.loadedLevels < 4
    ) {
      // context.commit(INIT, newUsername);
      await context.dispatch(doGetUserTree, {
        username: username,
        levels: 4,
      });
    }
    context.commit(CHANGE_ROOT_USERNAME, username);
  },
  async refreshTree(
    context: ActionContext<UserNetworkState, any>,
    visibleUsernames: string[]
  ) {
    // Deduplicate visible usernames to avoid redundant API calls
    const uniqueUsernames = [...new Set(visibleUsernames)];

    // Get all loaded nodes
    const allLoadedUsernames = Array.from(context.state.binaryTreeMap.keys());

    // Mark non-visible nodes as pending update
    const nonVisibleNodes = allLoadedUsernames.filter(
      (username) => !uniqueUsernames.includes(username)
    );
    context.commit(MARK_NODES_PENDING_UPDATE, nonVisibleNodes);

    // Refresh visible nodes using batch API
    await context.dispatch(doGetUserTreeBatch, {
      usernames: uniqueUsernames,
      levels: 1,
    });
  },
};

const getters = {
  getTreeForUser(state: UserNetworkState, getters: any, rootState: any) {
    return (username?: string): BinaryTreeNodeUser => {
      username =
        username?.toLowerCase() || rootState.auth.userProfileData._usernamePK;
      // console.log(username);
      // console.log("treeMap", state.binaryTreeMap);
      // console.log("treeNodes", state.binaryTreeNodes);
      if (username && state.binaryTreeMap.get) {
        const node = state.binaryTreeMap.get(username);
        if (node) {
          return node;
        }
      }
      return new BinaryTreeNodeUser();
    };
  },
  getRootUserNode(state: UserNetworkState): BinaryTreeNodeUser | undefined {
    if (state.binaryTreeMap.get) {
      return state.binaryTreeMap.get(state.rootNodeUsername);
    }
  },
  isNodePendingUpdate(state: UserNetworkState) {
    return (username: string): boolean => {
      return state.pendingUpdateNodes.has(username);
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
